import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFerrarinDotVDotComponent } from './simple-icons-ferrarin-dot-v-dot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFerrarinDotVDotComponent ],
    exports:      [ SimpleIconsFerrarinDotVDotComponent ],
    bootstrap:    []
})
export class SimpleIconsFerrarinDotVDotModule {}
